// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rJF3p","header":"styles_header__Ku6bd","row":"styles_row__Uvpxk","center":"styles_center__BrpeA","ml10":"styles_ml10__RgfgW"};